import { render, staticRenderFns } from "./RechargeList.vue?vue&type=template&id=254dfa70&scoped=true&"
import script from "./RechargeList.vue?vue&type=script&lang=js&"
export * from "./RechargeList.vue?vue&type=script&lang=js&"
import style0 from "./RechargeList.vue?vue&type=style&index=0&id=254dfa70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254dfa70",
  null
  
)

export default component.exports